import styled from 'styled-components';
import {
  PRIMARY_COLOR,
  SECONDARY_COLOR_2,
  SECONDARY_COLOR_5
} from '../../const/color';
import { FAMILY_FONT_CONTROL } from '../../const/text';
import {CheckBox} from "./index";
import {device} from "../../const/device"

export const Item = styled.input.attrs(() => ({ type: 'text', autocomplete: 'false'}))<{themeColor: string}>`
  background: ${props => props.themeColor == 'black'?'#2e2e2e':'#fff'};
  color: ${props => props.themeColor == 'black'?'#7a7b7e':''};
  border: 1px solid ${SECONDARY_COLOR_5};
  padding: 10px 16px;
  font-family: ${FAMILY_FONT_CONTROL} !important;
  border-radius: 2px;
  line-height: 160%;
  font-size: 16px;
  flex-grow: 1;
  outline: 0;
  margin: 0;
  
  width: 100%;
  
  &:hover {
    border: ${props => props.themeColor == 'black' ?'0px': '1px solid #A0A3A8'};    
  }
  &:focus {
    border: 1px solid ${PRIMARY_COLOR};    
  }
`;

export const SearchItem = styled(Item)<{themeColor: string}>`
  padding: 5px 10px;
  flex-grow: 0;
  background: ${props => props.themeColor == 'black'?'#2e2e2e':'#fff'}
  @media(${device.tablet}){
    font-size: 14px;
  }
`;

export const FontsSearchWrap = styled.div<{themeColor: string}>`
  padding: 5px;
  background: ${props => props.themeColor == 'black'?'#2e2e2e':'#fff'}
`;

export const CheckboxContainer = styled.div`
  position: relative;
  display: flex;
  flex-grow: 1;
  ${Item} {
    padding-right: 40px;
  }
  ${CheckBox.Item} {
    position: absolute;
    right: 10px;
    top: 0;
    bottom: 0;
    margin: auto 0;
  }
`;

